'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../../kit/box'
import Pressable from '../../kit/pressable'
import Text from '../../kit/text'

/* -----------------------------------------------------------------------------
 * EmptyState
 * -------------------------------------------------------------------------- */

export type EmptyStateProps = BoxProps & {
  actionLabel?: string
  description?: string
  onAction?: () => void
  title: string
}

function EmptyState({
  actionLabel,
  description,
  onAction,
  title,
  ...otherProps
}: EmptyStateProps) {
  return (
    <Box alignItems='center' px='20' py='48' {...otherProps}>
      <Text font='pro.text.15.semibold' textColor='proInk'>
        {title}
      </Text>
      {description ? (
        <Text font='pro.text.13.regular' mt='08' textColor='proTextFaint'>
          {description}
        </Text>
      ) : null}
      {actionLabel && onAction ? (
        <Pressable mt='16' onPress={onAction}>
          <Text font='pro.text.12.semibold' textColor='proAccent'>
            {actionLabel}
          </Text>
        </Pressable>
      ) : null}
    </Box>
  )
}

export default EmptyState
